/**
 * Music Theory Module
 * 
 * This module provides musical timing calculations including:
 * - Bar duration calculation based on BPM
 * - Song length calculation based on number of bars
 * 
 * Ported from looperc-factory/src/music_theory.py
 */

/**
 * Calculate time duration for one bar given BPM.
 * 
 * Formula: barTime = (TR * pulseCompas) / BPM
 * 
 * @param bpm - Beats per minute (tempo)
 * @param pulseCompas - Time signature numerator (beats per bar, default: 4)
 * @param tr - Time reference in seconds (default: 60)
 * @returns Time in seconds for one bar
 * 
 * @example
 * ```typescript
 * barTimeCalc(120);  // 120 BPM, 4/4 time -> 2.0
 * barTimeCalc(90, 4);  // 90 BPM, 4/4 time -> 2.6666666666666665
 * barTimeCalc(140, 3);  // 140 BPM, 3/4 time -> 1.2857142857142858
 * ```
 * 
 * @remarks
 * - Standard 4/4 time signature: pulseCompas=4
 * - Waltz (3/4 time): pulseCompas=3
 * - 6/8 time: pulseCompas=6
 */
export function barTimeCalc(bpm: number, pulseCompas: number = 4, tr: number = 60): number {
  return (tr * pulseCompas) / bpm;
}


